var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "no-hero g-px g-mb" }, [
    _c("div", { staticClass: "row-c-nm event-form" }, [
      _c("h2", [_vm._v(_vm._s(_vm.heading))]),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "form form--error-handling",
          attrs: { enctype: "multipart/form-data" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [
          _c("div", { staticClass: "swiper-container" }, [
            _c("div", { staticClass: "swiper-wrapper" }, [
              _vm.newEntry
                ? _c("div", { staticClass: "swiper-slide" }, [
                    _c(
                      "h3",
                      [
                        _vm._t("step1-title", [
                          _vm._v("Deel het verhaal van jouw held")
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "rte mb-6" },
                      [_vm._t("step1-text", [_vm._m(0)])],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "swiper-slider__btn-row" }, [
                      _c("span", [
                        _vm._v(
                          "Stap " +
                            _vm._s(_vm.slide) +
                            "/" +
                            _vm._s(_vm.totalSlides)
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--green",
                          attrs: { type: "button" },
                          on: { click: _vm.nextSlide }
                        },
                        [_vm._v("Volgende")]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "swiper-slide" }, [
                _c("h3", [_vm._t("step2-title", [_vm._v("Jouw gegevens")])], 2),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rte mb-6" },
                  [_vm._t("step2-text")],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.firstName.error }
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.firstName.val,
                            expression: "fields.firstName.val"
                          }
                        ],
                        attrs: {
                          id: "input-first-name",
                          name: "firstName",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.firstName.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorReq(_vm.fields.firstName)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.firstName,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.firstName.error
                        ? _c("span", [
                            _vm._v("Gelieve een voornaam in te geven.")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.lastName.error }
                    },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.lastName.val,
                            expression: "fields.lastName.val"
                          }
                        ],
                        attrs: {
                          id: "input-last-name",
                          name: "lastName",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.lastName.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorReq(_vm.fields.lastName)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.lastName,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.lastName.error
                        ? _c("span", [
                            _vm._v("Gelieve een familienaam in te geven.")
                          ])
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.email.error }
                    },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.email.val,
                            expression: "fields.email.val"
                          }
                        ],
                        attrs: {
                          id: "input-email",
                          name: "email",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.email.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorMail(_vm.fields.email)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.email,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.email.error
                        ? _c("span", [
                            _vm._v(
                              "Gelieve een correct e-mailadres in te geven."
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "input-phone" } }, [
                      _vm._v("Telefoonnummer")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fields.phone.val,
                          expression: "fields.phone.val"
                        }
                      ],
                      attrs: { id: "input-phone", name: "phone", type: "text" },
                      domProps: { value: _vm.fields.phone.val },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.fields.phone, "val", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-slider__btn-row" }, [
                  _c("span", [
                    _vm._v(
                      "Stap " +
                        _vm._s(_vm.slide) +
                        "/" +
                        _vm._s(_vm.totalSlides)
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.newEntry
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn--rose",
                            attrs: { type: "button" },
                            on: { click: _vm.prevSlide }
                          },
                          [_vm._v("Terug")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--green",
                        attrs: { type: "button" },
                        on: { click: _vm.nextSlide }
                      },
                      [_vm._v("Volgende")]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "swiper-slide" }, [
                _c("h3", [_vm._t("step3-title", [_vm._v("Jouw held")])], 2),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rte mb-6" },
                  [
                    _vm._t("step3-text", [
                      _c("p", [
                        _vm._v(
                          "\n                                    Mooie verhalen over kleine helden. Vul hieronder alle gegevens in van jouw held.\n                                "
                        )
                      ])
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.firstNameDeceased.error }
                    },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.firstNameDeceased.val,
                            expression: "fields.firstNameDeceased.val"
                          }
                        ],
                        attrs: {
                          id: "input-first-name-deceased",
                          name: "firstNameDeceased",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.firstNameDeceased.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorReq(
                              _vm.fields.firstNameDeceased
                            )
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.firstNameDeceased,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.firstNameDeceased.error
                        ? _c("span", [
                            _vm._v("Gelieve een voornaam in te geven.")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.lastNameDeceased.error }
                    },
                    [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.lastNameDeceased.val,
                            expression: "fields.lastNameDeceased.val"
                          }
                        ],
                        attrs: {
                          id: "input-last-name-deceased",
                          name: "lastNameDeceased",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.lastNameDeceased.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorReq(
                              _vm.fields.lastNameDeceased
                            )
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.lastNameDeceased,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.lastNameDeceased.error
                        ? _c("span", [
                            _vm._v("Gelieve een familienaam in te geven.")
                          ])
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", [_vm._v("Foto")]),
                      _vm._v(" "),
                      _c("file-upload", {
                        attrs: {
                          "folder-id": _vm.asset.folderId,
                          "field-id": _vm.asset.fieldId,
                          "element-id": _vm.asset.elementId,
                          "original-name": _vm.asset.originalName,
                          url: _vm.asset.url
                        },
                        on: { uploadComplete: _vm.onUploadComplete }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.dayOfBirth.error }
                    },
                    [
                      _vm._m(6),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.dayOfBirth.val,
                            expression: "fields.dayOfBirth.val"
                          }
                        ],
                        attrs: {
                          id: "input-day-of-birth",
                          name: "dayOfBirth",
                          type: "text",
                          placeholder: "dd/mm/jjjj"
                        },
                        domProps: { value: _vm.fields.dayOfBirth.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorDate(_vm.fields.dayOfBirth)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.dayOfBirth,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.dayOfBirth.error
                        ? _c("span", [
                            _vm._v(
                              "Gelieve een correcte datum in te geven, bv. 01/01/2020."
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.dayOfDeath.error }
                    },
                    [
                      _vm._m(7),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.dayOfDeath.val,
                            expression: "fields.dayOfDeath.val"
                          }
                        ],
                        attrs: {
                          id: "input-day-of-death",
                          name: "dayOfDeath",
                          type: "text",
                          placeholder: "dd/mm/jjjj"
                        },
                        domProps: { value: _vm.fields.dayOfDeath.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorDate(_vm.fields.dayOfDeath)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.dayOfDeath,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.dayOfDeath.error
                        ? _c("span", [
                            _vm._v(
                              "Gelieve een correcte datum in te geven, bv. 01/01/2020."
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.gender.error }
                    },
                    [
                      _vm._m(8),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fields.gender.val,
                              expression: "fields.gender.val"
                            }
                          ],
                          attrs: {
                            hidden: "",
                            id: "input-gender-female",
                            name: "gender",
                            type: "radio",
                            value: "female"
                          },
                          domProps: {
                            checked: _vm._q(_vm.fields.gender.val, "female")
                          },
                          on: {
                            change: [
                              function($event) {
                                return _vm.$set(
                                  _vm.fields.gender,
                                  "val",
                                  "female"
                                )
                              },
                              function($event) {
                                return _vm.checkErrorChk(_vm.fields.gender)
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "input-gender-female" } }, [
                          _vm._v("Vrouw")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fields.gender.val,
                              expression: "fields.gender.val"
                            }
                          ],
                          attrs: {
                            hidden: "",
                            id: "input-gender-male",
                            name: "gender",
                            type: "radio",
                            value: "male"
                          },
                          domProps: {
                            checked: _vm._q(_vm.fields.gender.val, "male")
                          },
                          on: {
                            change: [
                              function($event) {
                                return _vm.$set(
                                  _vm.fields.gender,
                                  "val",
                                  "male"
                                )
                              },
                              function($event) {
                                return _vm.checkErrorChk(_vm.fields.gender)
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "input-gender-male" } }, [
                          _vm._v("Man")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fields.gender.val,
                              expression: "fields.gender.val"
                            }
                          ],
                          attrs: {
                            hidden: "",
                            id: "input-gender-neutral",
                            name: "gender",
                            type: "radio",
                            value: "neutral"
                          },
                          domProps: {
                            checked: _vm._q(_vm.fields.gender.val, "neutral")
                          },
                          on: {
                            change: [
                              function($event) {
                                return _vm.$set(
                                  _vm.fields.gender,
                                  "val",
                                  "neutral"
                                )
                              },
                              function($event) {
                                return _vm.checkErrorChk(_vm.fields.gender)
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { attrs: { for: "input-gender-neutral" } },
                          [_vm._v("X")]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.fields.gender.error
                        ? _c("span", [
                            _vm._v("Gelieve een antwoord aan te duiden.")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "input-occupation" } }, [
                      _vm._v("Beroep")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fields.occupation.val,
                          expression: "fields.occupation.val"
                        }
                      ],
                      attrs: {
                        id: "input-occupation",
                        name: "occupation",
                        type: "text"
                      },
                      domProps: { value: _vm.fields.occupation.val },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.fields.occupation,
                            "val",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: { error: _vm.fields.covid19Victim.error }
                  },
                  [
                    _vm._m(9),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-0" }, [
                      _vm._v(
                        "We vragen dit omdat er in sommige gemeentes plannen zijn om specifieke Covid-19 herdenkingen te organiseren."
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.covid19Victim.val,
                            expression: "fields.covid19Victim.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-covid19-yes",
                          name: "covid19Victim",
                          type: "radio",
                          value: "yes"
                        },
                        domProps: {
                          checked: _vm._q(_vm.fields.covid19Victim.val, "yes")
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.covid19Victim,
                                "val",
                                "yes"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorChk(_vm.fields.covid19Victim)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "input-covid19-yes" } }, [
                        _vm._v("Ja")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.covid19Victim.val,
                            expression: "fields.covid19Victim.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-covid19-no",
                          name: "covid19Victim",
                          type: "radio",
                          value: "no"
                        },
                        domProps: {
                          checked: _vm._q(_vm.fields.covid19Victim.val, "no")
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.covid19Victim,
                                "val",
                                "no"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorChk(_vm.fields.covid19Victim)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "input-covid19-no" } }, [
                        _vm._v("Nee")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.covid19Victim.val,
                            expression: "fields.covid19Victim.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-covid19-dont-know",
                          name: "covid19Victim",
                          type: "radio",
                          value: "dontKnow"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.fields.covid19Victim.val,
                            "dontKnow"
                          )
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.covid19Victim,
                                "val",
                                "dontKnow"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorChk(_vm.fields.covid19Victim)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "input-covid19-dont-know" } },
                        [_vm._v("Ik weet dit niet")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.fields.covid19Victim.error
                      ? _c("span", [
                          _vm._v("Gelieve een antwoord aan te duiden.")
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: { error: _vm.fields.restingPlace.error }
                  },
                  [
                    _vm._m(10),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.restingPlace.val,
                            expression: "fields.restingPlace.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-resting-place-home",
                          name: "restingPlace",
                          type: "radio",
                          value: "home"
                        },
                        domProps: {
                          checked: _vm._q(_vm.fields.restingPlace.val, "home")
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.restingPlace,
                                "val",
                                "home"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorChk(_vm.fields.restingPlace)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "input-resting-place-home" } },
                        [_vm._v("Thuis")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.restingPlace.val,
                            expression: "fields.restingPlace.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-resting-place-cemetery",
                          name: "restingPlace",
                          type: "radio",
                          value: "cemetery"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.fields.restingPlace.val,
                            "cemetery"
                          )
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.restingPlace,
                                "val",
                                "cemetery"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorChk(_vm.fields.restingPlace)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "input-resting-place-cemetery" } },
                        [_vm._v("Begraafplaats")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.restingPlace.val,
                            expression: "fields.restingPlace.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-resting-place-na",
                          name: "restingPlace",
                          type: "radio",
                          value: "na"
                        },
                        domProps: {
                          checked: _vm._q(_vm.fields.restingPlace.val, "na")
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.restingPlace,
                                "val",
                                "na"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorChk(_vm.fields.restingPlace)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "input-resting-place-na" } },
                        [_vm._v("Niet van toepassing")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.fields.restingPlace.error
                      ? _c("span", [
                          _vm._v("Gelieve een antwoord aan te duiden.")
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.fields.restingPlace.val == "cemetery",
                        expression: "fields.restingPlace.val == 'cemetery'"
                      }
                    ]
                  },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "input-tomb-number" } }, [
                        _vm._v("Zerknummer of -locatie")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.tombNumber.val,
                            expression: "fields.tombNumber.val"
                          }
                        ],
                        attrs: {
                          id: "input-tomb-number",
                          name: "tombNumber",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.tombNumber.val },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.tombNumber,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-field-wrapper" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: { error: _vm.fields.locationStreet.error }
                        },
                        [
                          _vm._m(11),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.fields.locationStreet.val,
                                expression: "fields.locationStreet.val"
                              }
                            ],
                            attrs: {
                              id: "input-location-street",
                              name: "locationStreet",
                              type: "text"
                            },
                            domProps: { value: _vm.fields.locationStreet.val },
                            on: {
                              keyup: function($event) {
                                return _vm.checkErrorReq(
                                  _vm.fields.locationStreet
                                )
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.fields.locationStreet,
                                  "val",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.fields.locationStreet.error
                            ? _c("span", [
                                _vm._v("Gelieve een straat in te geven.")
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "w-1/5" }, [
                          _c("label", { attrs: { for: "input-location-nr" } }, [
                            _vm._v("Nr")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.fields.locationNr.val,
                                expression: "fields.locationNr.val"
                              }
                            ],
                            staticStyle: { "border-color": "#52746A" },
                            attrs: {
                              id: "input-location-nr",
                              name: "locationNr",
                              type: "text"
                            },
                            domProps: { value: _vm.fields.locationNr.val },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.fields.locationNr,
                                  "val",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-field-wrapper" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: { error: _vm.fields.locationZipcode.error }
                        },
                        [
                          _vm._m(12),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.fields.locationZipcode.val,
                                expression: "fields.locationZipcode.val"
                              }
                            ],
                            attrs: {
                              id: "input-location-zipcode",
                              name: "zipcode",
                              type: "text"
                            },
                            domProps: { value: _vm.fields.locationZipcode.val },
                            on: {
                              keyup: function($event) {
                                return _vm.checkErrorReq(
                                  _vm.fields.locationZipcode
                                )
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.fields.locationZipcode,
                                  "val",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.fields.locationZipcode.error
                            ? _c("span", [
                                _vm._v("Gelieve een postcode in te geven.")
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: { error: _vm.fields.locationCity.error }
                        },
                        [
                          _vm._m(13),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.fields.locationCity.val,
                                expression: "fields.locationCity.val"
                              }
                            ],
                            attrs: {
                              id: "input-location-city",
                              name: "locationCity",
                              type: "text"
                            },
                            domProps: { value: _vm.fields.locationCity.val },
                            on: {
                              keyup: function($event) {
                                return _vm.checkErrorReq(
                                  _vm.fields.locationCity
                                )
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.fields.locationCity,
                                  "val",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.fields.locationCity.error
                            ? _c("span", [
                                _vm._v(
                                  "Gelieve een gemeente of stad in te geven."
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-slider__btn-row" }, [
                  _c("span", [
                    _vm._v(
                      "Stap " +
                        _vm._s(_vm.slide) +
                        "/" +
                        _vm._s(_vm.totalSlides)
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--rose",
                        attrs: { type: "button" },
                        on: { click: _vm.prevSlide }
                      },
                      [_vm._v("Terug")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--green",
                        attrs: { type: "button" },
                        on: { click: _vm.nextSlide }
                      },
                      [_vm._v("Volgende")]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "swiper-slide" }, [
                _c(
                  "h3",
                  [
                    _vm._t("step4-title", [_vm._v("Het verhaal van mijn held")])
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rte mb-6" },
                  [_vm._t("step4-text")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: { error: _vm.fields.title.error }
                  },
                  [
                    _vm._m(14),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fields.title.val,
                          expression: "fields.title.val"
                        }
                      ],
                      attrs: { id: "input-title", name: "title", type: "text" },
                      domProps: { value: _vm.fields.title.val },
                      on: {
                        keyup: function($event) {
                          return _vm.checkErrorReq(_vm.fields.title)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.fields.title, "val", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.fields.title.error
                      ? _c("span", [_vm._v("Gelieve een titel in te geven.")])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: { error: _vm.fields.text.error }
                  },
                  [
                    _vm._m(15),
                    _vm._v(" "),
                    _c("small", [
                      _vm._v(
                        "ENTER = nieuwe paragraaf, SHIFT+ENTER = nieuwe regel"
                      )
                    ]),
                    _vm._v(" "),
                    _c("ckeditor", {
                      attrs: { editor: _vm.editor, config: _vm.editorConfig },
                      on: {
                        keyup: function($event) {
                          return _vm.checkErrorReq(_vm.fields.text)
                        }
                      },
                      model: {
                        value: _vm.fields.text.val,
                        callback: function($$v) {
                          _vm.$set(_vm.fields.text, "val", $$v)
                        },
                        expression: "fields.text.val"
                      }
                    }),
                    _vm._v(" "),
                    _vm.fields.text.error
                      ? _c("span", [_vm._v("Gelieve een tekst in te geven.")])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: { error: _vm.fields.consentPublication.error }
                  },
                  [
                    _vm._m(16),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.consentPublication.val,
                            expression: "fields.consentPublication.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-consent-publication-true",
                          name: "consentPublication",
                          type: "radio",
                          value: "yes"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.fields.consentPublication.val,
                            "yes"
                          )
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.consentPublication,
                                "val",
                                "yes"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorChk(
                                _vm.fields.consentPublication
                              )
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "input-consent-publication-true" } },
                        [_vm._v("Ja")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.consentPublication.val,
                            expression: "fields.consentPublication.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-consent-publication-false",
                          name: "consentPublication",
                          type: "radio",
                          value: "no"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.fields.consentPublication.val,
                            "no"
                          )
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.consentPublication,
                                "val",
                                "no"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorChk(
                                _vm.fields.consentPublication
                              )
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "input-consent-publication-false" } },
                        [_vm._v("Nee")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.fields.consentPublication.error
                      ? _c("span", [
                          _vm._v("Gelieve een antwoord aan te duiden.")
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: { error: _vm.fields.consentFamily.error }
                  },
                  [
                    _vm._m(17),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.consentFamily.val,
                            expression: "fields.consentFamily.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-consent-family-true",
                          name: "consentFamily",
                          type: "radio",
                          value: "yes"
                        },
                        domProps: {
                          checked: _vm._q(_vm.fields.consentFamily.val, "yes")
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.consentFamily,
                                "val",
                                "yes"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorChk(_vm.fields.consentFamily)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "input-consent-family-true" } },
                        [_vm._v("Ja")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.consentFamily.val,
                            expression: "fields.consentFamily.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-consent-family-false",
                          name: "consentFamily",
                          type: "radio",
                          value: "no"
                        },
                        domProps: {
                          checked: _vm._q(_vm.fields.consentFamily.val, "no")
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.consentFamily,
                                "val",
                                "no"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorChk(_vm.fields.consentFamily)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "input-consent-family-false" } },
                        [_vm._v("Nee")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.fields.consentFamily.error
                      ? _c("span", [
                          _vm._v("Gelieve een antwoord aan te duiden.")
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: {
                      error: _vm.fields.consentPrivacyPolicyAndConditions.error
                    }
                  },
                  [
                    _vm._m(18),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.fields.consentPrivacyPolicyAndConditions.val,
                            expression:
                              "fields.consentPrivacyPolicyAndConditions.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-consent-policies-true",
                          name: "consentPrivacyPolicyAndConditions",
                          type: "radio",
                          value: "yes"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.fields.consentPrivacyPolicyAndConditions.val,
                            "yes"
                          )
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.consentPrivacyPolicyAndConditions,
                                "val",
                                "yes"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorConsent(
                                _vm.fields.consentPrivacyPolicyAndConditions
                              )
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "input-consent-policies-true" } },
                        [_vm._v("Ja")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.fields.consentPrivacyPolicyAndConditions.val,
                            expression:
                              "fields.consentPrivacyPolicyAndConditions.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-consent-policies-false",
                          name: "consentPrivacyPolicyAndConditions",
                          type: "radio",
                          value: "no"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.fields.consentPrivacyPolicyAndConditions.val,
                            "no"
                          )
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.consentPrivacyPolicyAndConditions,
                                "val",
                                "no"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorConsent(
                                _vm.fields.consentPrivacyPolicyAndConditions
                              )
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "input-consent-policies-false" } },
                        [_vm._v("Nee")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.fields.consentPrivacyPolicyAndConditions.error
                      ? _c("span", [_vm._v("Gelieve akkoord te gaan.")])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: { error: _vm.fields.consentUploadStory.error }
                  },
                  [
                    _vm._m(19),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.consentUploadStory.val,
                            expression: "fields.consentUploadStory.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-consent-upload-true",
                          name: "consentUploadStory",
                          type: "radio",
                          value: "yes"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.fields.consentUploadStory.val,
                            "yes"
                          )
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.consentUploadStory,
                                "val",
                                "yes"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorConsent(
                                _vm.fields.consentUploadStory
                              )
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "input-consent-upload-true" } },
                        [_vm._v("Ja")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.consentUploadStory.val,
                            expression: "fields.consentUploadStory.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-consent-upload-false",
                          name: "consentUploadStory",
                          type: "radio",
                          value: "no"
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.fields.consentUploadStory.val,
                            "no"
                          )
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.consentUploadStory,
                                "val",
                                "no"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorConsent(
                                _vm.fields.consentUploadStory
                              )
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "input-consent-upload-false" } },
                        [_vm._v("Nee")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.fields.consentUploadStory.error
                      ? _c("span", [_vm._v("Gelieve akkoord te gaan.")])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-slider__btn-row" }, [
                  _c("span", [
                    _vm._v(
                      "Stap " +
                        _vm._s(_vm.slide) +
                        "/" +
                        _vm._s(_vm.totalSlides)
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--rose",
                        attrs: { type: "button" },
                        on: { click: _vm.prevSlide }
                      },
                      [_vm._v("Terug")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--green",
                        attrs: { type: "submit" }
                      },
                      [_vm._v("Verzenden")]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "swiper-slide" }, [
                _c(
                  "h3",
                  [_vm._t("step5-title", [_vm._v("Verhaal verstuurd")])],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rte mb-6" },
                  [_vm._t("step5-text", [_c("p", [_vm._v("Bedankt!")])])],
                  2
                )
              ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n                                    Reveil vindt het een mooie gedachte: een plek maken waar de levensverhalen van alle vroegere inwoners van onze gemeentes worden opgeslagen. Via dit formulier kan je een verhaal toevoegen aan de Reveil verhalenbank."
      ),
      _c("br"),
      _vm._v(
        "\n                                    We zoeken geen deprimerende teksten of uitgebreide biografieën, maar mooie, inspirerende anekdotes vol menselijkheid. Het hoeft zeker geen grote literatuur te zijn. Met die teksten gaan we aan de slag. Tijdens het herdenkingsmoment op 1 november krijgen deze kleine verhalen een nieuw leven.\n                                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-first-name" } }, [
      _vm._v("Voornaam "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-last-name" } }, [
      _vm._v("Familienaam "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-email" } }, [
      _vm._v("E-mailadres "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-first-name-deceased" } }, [
      _vm._v("Voornaam "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-last-name-deceased" } }, [
      _vm._v("Familienaam "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-day-of-birth" } }, [
      _vm._v("Geboortedatum "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-day-of-death" } }, [
      _vm._v("Sterfdatum "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Geslacht "), _c("span", [_vm._v("*")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Gaat dit verhaal over een Covid-19 slachtoffer? "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Rustplaats "), _c("span", [_vm._v("*")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-location-street" } }, [
      _vm._v("Straat "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-location-zipcode" } }, [
      _vm._v("Postcode "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-location-city" } }, [
      _vm._v("Gemeente of stad "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-title" } }, [
      _vm._v("Titel "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Verhaal "), _c("span", [_vm._v("*")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v(
        "Ik geef de toestemming aan vzw Reveil om dit verhaal op de website van Reveil te publiceren "
      ),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v(
        "Ik heb de toestemming van andere familieleden en betrokkenen om dit verhaal te delen "
      ),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Ik ga akkoord met de "),
      _c("a", { attrs: { href: "/gebruiksvoorwaarden", target: "_blank" } }, [
        _vm._v("gebruiksvoorwaarden")
      ]),
      _vm._v(" en de verwerking van persoonsgegevens zoals omschreven in de "),
      _c("a", { attrs: { href: "/privacyverklaring", target: "_blank" } }, [
        _vm._v("privacyverklaring")
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v(
        "Ik ben 13 jaar of ouder of ik ben ouder of (wettelijke) voogd van een kind dat jonger is dan 13 jaar, en geef toestemming voor het opladen van het verhaal onder de voorwaarden, inclusief ivm verwerking van persoonsgegevens, omschreven in de "
      ),
      _c("a", { attrs: { href: "/gebruiksvoorwaarden", target: "_blank" } }, [
        _vm._v("gebruiksvoorwaarden")
      ]),
      _vm._v(" en de "),
      _c("a", { attrs: { href: "/privacyverklaring", target: "_blank" } }, [
        _vm._v("privacyverklaring")
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("*")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }